import { useTranslation } from 'next-i18next';
import type { FC } from 'react';
import { EXTERNAL_PATHS, PATHS } from 'src/common/constants';
import useFeatureFlag from 'src/common/hooks/useFeatureFlag';
import Button from '../ButtonDS22';
import ComponentWrapper from '../NestedMenu/ComponentWrapper';
import style from './Navigation.module.scss';

const AuthNavItem: FC = () => {
  const [t] = useTranslation('navbar');
  const isAuthMigrationEnabled = useFeatureFlag('auth-migration');

  return (
    <ComponentWrapper>
      <div className={style.sidebarAuth}>
        <Button
          type="link"
          href={isAuthMigrationEnabled ? PATHS.LOGIN : EXTERNAL_PATHS.LOGIN}
          variant="tertiary"
        >
          {t('login')}
        </Button>
        <Button
          type="link"
          href={isAuthMigrationEnabled ? PATHS.REGISTER : EXTERNAL_PATHS.REGISTER}
        >
          {t('create-account')}
        </Button>
      </div>
    </ComponentWrapper>
  );
};
export default AuthNavItem;
